export default {
  en: {
    hotel: 'Hotel',
    keyword: 'Keyword',
    hotelList: 'Hotel List',
    hotelName: 'Hotel Name',
    hotels: 'Hotels',
    code: 'Code',
    status: 'Status',
    createdDate: 'Created Date',
    newHotel: 'New Hotel'
  },
  th: {
    hotel: 'โรงแรม',
    keyword: 'คำที่ต้องการค้นหา',
    hotelList: 'รายชื่อโรงแรม',
    hotelName: 'ชื่อโรงแรม',
    hotels: 'ชื่อ',
    code: 'โค้ด',
    status: 'สถานะ',
    createdDate: 'วันที่สร้าง',
    newHotel: 'สร้างโรงแรม'
  }
}
